<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:wheel="wheelChanged">
      <div class="modalOverlay2" :class="{open: overlayOpen}"></div>
      <div class="close" v-on:click="close()"></div>
      <div class="imgPreview" :style="{left: `${pos.x}px`,
        top: `${pos.y}px`, width: `${pos.w}px`, height: `${pos.h}px`,
        'background-image': `url(${media.imageLg})`}" v-if="media"
        :class="{open: overlayOpen, hasCaption: media.caption}"></div>
      <div class="mediaNav p" v-on:click="prevImg"
        v-if="i > 0"></div>
      <div class="mediaNav n" v-on:click="nextImg"
        v-if="i < allMedia.length"></div>
      <div class="pageInfo">{{i+1}}/{{allMedia.length}}</div>
      <div class="caption" v-if="media.caption" v-html="media.caption"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'videoDialog',
  components: {},
  data() {
    return {
      show: false,
      next: null,
      overlayOpen: false,
      allMedia: [],
      media: null,
      i: 0,
      pos: {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      },
    };
  },
  methods: {
    keyPressed(e) {
      if (!this.show) return;
      if (e.key === 'Escape') {
        this.close();
      } else if (e.key === 'ArrowRight') {
        this.nextImg();
      } else if (e.key === 'ArrowLeft') {
        this.prevImg();
      }
    },
    prevImg() {
      if (this.i <= 0) return;
      this.i -= 1;
      this.media = this.allMedia[this.i];
    },
    nextImg() {
      if (this.i + 1 >= this.allMedia.length) return;
      this.i += 1;
      this.media = this.allMedia[this.i];
    },
    wheelChanged() {
      // this.close();
    },
    open(d, n) {
      this.next = n;
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
      this.media = d.item;
      this.allMedia = d.items;
      this.i = d.i;
      const pos = d.e.target.getBoundingClientRect();
      this.pos.x = pos.left;
      this.pos.y = pos.top;
      this.pos.w = d.e.target.offsetWidth;
      this.pos.h = d.e.target.offsetHeight;
      this.show = true;
      setTimeout(() => {
        this.overlayOpen = true;
      });
    },
    close() {
      this.overlayOpen = false;
      setTimeout(() => {
        this.show = false;
        document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
        if (this.next) this.next();
      }, 300);
    },
  },
  created() { window.addEventListener('keydown', this.keyPressed); },
  destroyed() { document.removeEventListener('keydown', this.keyPressed); },
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 991;
  .modalOverlay2{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: #fff;
    z-index: 1;
    opacity: 0;
    transition: all .6s ease;
    &.open{
      opacity: 1;
    }
  }
  .close{
    width: 46px; height: 46px;
    // border-radius: 50%;
    position: absolute;
    right: 20px; top: 20px;
    background-image: url(../assets/close.png);
    background-size: 18px auto;
    border-radius: 50%;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 91;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5f5;
    }
  }
  .imgPreview{
    z-index: 7;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    transition: all .3s ease;
    position: relative;
    border-radius: 7px;
    &:before{
      content: "";
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: #222;
      border-radius: 7px;
      transition: all .15s ease;
    }
    &.open{
      left: 5% !important;
      top: 5% !important;
      width: 90% !important;
      height: 90% !important;
      border-radius: 0;
      &.hasCaption{
        height: calc(90% - 96px) !important;
      }
      &:before{
        opacity: 0;
      }
    }
  }
  .caption{
    position: absolute;
    left: 20px; right: 20px;
    bottom: 40px;
    color: #444;
    text-align: center;
    z-index: 99;
    line-height: 1.2;
    font-size: 15px;
  }
  .pageInfo{
    position: absolute;
    z-index: 8;
    right: 20px; bottom: 20px;
    color: #767676;
    font-size: 15px;
  }
  .mediaNav{
    position: absolute;
    top: 50%;
    width: 44px; height: 44px;
    border-radius: 50%;
    background-color: #fff;
    background-size: 20px auto;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 9;
    cursor: pointer;
    transition: all .3s ease;
    margin-top: -22px;
    @media (max-width: 840px) {
      width: 36px; height: 36px;
      background-size: 16px auto;
    }
    &:hover{
      background-color: #f5f5f5;
    }
    &.p{
      background-image: url(../assets/arrow-left-black.png);
      left: 20px;
      @media (max-width: 840px) {
        left: 5px;
      }
    }
    &.n{
      background-image: url(../assets/arrow-right-black.png);
      right: 20px;
      @media (max-width: 840px) {
        right: 5px;
      }
    }
  }
}
</style>
